import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { header, host } from "../globalVariables";
import { api, cleanJSON, formatCurrency, isJSON, robustJsonParse } from "../pureFunctions";
import { formatText } from "../formatFunctions";
import LoadingAnimation from "../LoadingAnimation";

import questionIcon from "../img/bildIcon.png";
import kiIcon from "../img/ki_kennzeichnung_baur.png";
import pinIcon from "../img/pin_gruen.png";
import { generateImage } from "./generateImage";

export default function ImageGenerator({ basicdata, fieldconfiguration, userObjects }) {
   const [loading, setLoading] = useState(false);
   const [aiResponse, setAiResponse] = useState("");
   const [show, setShow] = useState(false);
   const [prompt, setPrompt] = useState("");

   // Ausgewählte Dateien
   const [backgroundFile, setBackgroundFile] = useState(null);
   const [personFile, setPersonFile] = useState(null);

   // Ergebnis von generateImage ({ url, blob, download })
   const [result, setResult] = useState(null);

   // Objekt-URL des alten Ergebnisses freigeben, wenn ein neues erzeugt wird
   useEffect(() => {
      return () => {
         if (result?.url) URL.revokeObjectURL(result.url);
      };
   }, [result]);

   async function createImage() {
      setLoading(true);
      try {
         console.log(userObjects[basicdata?.benutzer]);

         const benutzer = userObjects[basicdata?.benutzer];

         const dateiname = `${encodeURIComponent(benutzer.Vorname.replace(" ", ""))}_${encodeURIComponent(benutzer.Nachname.replace(" ", ""))}.png`;
         const src = `${host + "/images/"}Mitarbeiter/${dateiname}`;

         let zeile3 = `EA ${fieldconfiguration.estate?.energieausweistyp?.permittedvalues?.[basicdata?.energieausweistyp]} `;
         if (["Endenergiebedarf", "Bedarfsausweis Gewerbe"].includes(basicdata?.energieausweistyp)) {
            zeile3 += ` ${basicdata?.endenergiebedarf} kWh/(ma²)`;
         } else if (["Energieverbrauchskennwert", "Verbrauchsausweis Gewerbe"].includes(basicdata?.energieausweistyp)) {
            zeile3 += ` ${basicdata?.energieverbrauchskennwert} kWh/(ma²)`;
         }
         // zeile3 += ``;
         let zeile4 = `${basicdata?.befeuerung.map((item) => fieldconfiguration.estate?.befeuerung?.permittedvalues?.[item]).join(", ")} | ${basicdata?.heizungsart.map((item) => fieldconfiguration.estate?.heizungsart?.permittedvalues?.[item]).join(", ")} | Bj. ${basicdata.baujahr}`;
         if (basicdata.energyClass) {
            zeile3 += `, Kl. ${basicdata.energyClass}`;
         }
         const res = await generateImage(
            1080,
            1350,
            [
               { type: "image-center", src: backgroundFile, x: 0, y: 0, width: 1080, height: 950 },
               { type: "image-top", src: kiIcon, x: 800, y: 100, width: 280, height: 90 },
               { type: "gradient", y: 800, height: 100, color: "#444749" },
               { type: "image-top", src: personFile ?? src, x: 700, y: 600, width: 300, height: 1200 },
               { type: "image-top", src: pinIcon, x: 100, y: 1020, width: 30, height: 80 },

               {
                  type: "text",
                  text: formatCurrency(basicdata?.kaufpreis ?? ""),
                  x: 100,
                  y: 940,
                  fontSize: 80,
                  bold: true,
                  color: "#fff",
               },
               { type: "text", text: basicdata?.ort ?? "", x: 140, y: 1040, fontSize: 48, bold: false, color: "#fff" },

               {
                  type: "text",
                  text: `Obj. ${basicdata?.objektnr_extern} | ${fieldconfiguration.estate?.objektart?.permittedvalues?.[basicdata?.objektart]}`,
                  x: 100,
                  y: 1120,
                  fontSize: 28,
                  bold: false,
                  color: "#fff",
               },
               {
                  type: "text",
                  text: `${benutzer?.Anrede} ${benutzer?.Nachname} | Prov. ${basicdata.aussen_courtage} inkl. MwSt`,
                  x: 100,
                  y: 1160,
                  fontSize: 28,
                  bold: false,
                  color: "#fff",
               },
               {
                  type: "text",
                  text: zeile3,
                  x: 100,
                  y: 1200,
                  fontSize: 28,
                  bold: false,
                  color: "#fff",
               },{
                  type: "text",
                  text: zeile4,
                  x: 100,
                  y: 1240,
                  fontSize: 28,
                  bold: false,
                  color: "#fff",
               },
            ],
            { background: "#ffffff" },
         );
         console.log(fieldconfiguration);

         setResult(res);
      } catch (err) {
         console.error(err);
         alert("Bild konnte nicht erstellt werden.");
      } finally {
         setLoading(false);
      }
   }

   const handleClose = () => {
      setShow(false);
   };

   const handleShow = () => {
      setShow(true);
   };

   return (
      <>
         <div style={{ position: "relative" }}>
            <button
               onClick={() => {
                  handleShow();
               }}
               className="custom-button"
               style={{
                  position: "absolute",
                  width: "56px",
                  right: "420px",
                  zIndex: 0,
               }}
               title="Frage"
            >
               <img src={questionIcon} />
            </button>
         </div>
         <Modal show={show} size="xl" onHide={handleClose} dialogClassName="mt-5">
            <Modal.Header closeButton>{/* <Modal.Title>Frage</Modal.Title> */}</Modal.Header>
            <Modal.Body>
               {/*  <Alert>Hinweis.</Alert>
               <Row>
                  <Col>
                     <Form.Group className="mb-3" controlId="prompt">
                        <Form.Label>Frage</Form.Label>
                        <Form.Control
                           autoComplete="off"
                           placeholder="..."
                           style={{ minHeight: "120px", fieldSizing: "content" }}
                           as="textarea"
                           onChange={(e) => {
                              setPrompt(e.target.value);
                           }}
                           value={prompt}
                        />
                     </Form.Group>
                  </Col>
               </Row> */}

               <Row>
                  <Col md={6}>
                     <Form.Group className="mb-3" controlId="backgroundFile">
                        <Form.Label>Hintergrundbild (Pflicht)</Form.Label>
                        <Form.Control
                           type="file"
                           accept="image/*"
                           onChange={(e) => setBackgroundFile(e.target.files?.[0] ?? null)}
                        />
                     </Form.Group>
                  </Col>
                  <Col md={6}>
                     <Form.Group className="mb-3" controlId="personFile">
                        <Form.Label>Personenbild (optional)</Form.Label>
                        <Form.Control
                           type="file"
                           accept="image/*"
                           onChange={(e) => setPersonFile(e.target.files?.[0] ?? null)}
                        />
                     </Form.Group>
                  </Col>
               </Row>

               {result && (
                  <div className="mb-3 text-center">
                     <img
                        src={result.url}
                        alt="Erzeugtes Bild"
                        style={{ maxWidth: "540px", border: "1px solid #ddd" }}
                     />
                  </div>
               )}

               <div className="d-flex justify-content-end w-100">
                  <Button variant="secondary" disabled={loading || !backgroundFile} onClick={createImage}>
                     {loading ? <LoadingAnimation /> : "Bild erstellen"}
                  </Button>
                  <Button
                     className="ms-1"
                     variant="dark"
                     disabled={!result}
                     onClick={() => result?.download("bild.png")}
                  >
                     Bild herunterladen
                  </Button>
               </div>
            </Modal.Body>
         </Modal>
      </>
   );
}
